import { useEffect } from 'react';

/**
 * Hook to enable natural page scrolling for auth pages
 * This overrides the global overflow: hidden setting
 */
export function useAuthPage() {
  useEffect(() => {
    // Add class to enable scrolling
    document.documentElement.classList.add('auth-page');
    document.body.classList.add('auth-page');
    const root = document.getElementById('root');
    if (root) {
      root.classList.add('auth-page');
    }

    // Check if content exceeds viewport and adjust overflow accordingly
    const checkScrollNeeded = () => {
      const rootElement = document.getElementById('root');
      if (rootElement) {
        const needsScroll = rootElement.scrollHeight > window.innerHeight;
        if (needsScroll) {
          document.body.style.overflowY = 'auto';
        } else {
          document.body.style.overflowY = 'hidden';
        }
      }
    };

    // Check on mount and after a brief delay to ensure content is rendered
    checkScrollNeeded();
    const timeoutId = setTimeout(checkScrollNeeded, 100);

    // Also check on resize
    window.addEventListener('resize', checkScrollNeeded);

    // Cleanup: remove class when component unmounts
    return () => {
      clearTimeout(timeoutId);
      window.removeEventListener('resize', checkScrollNeeded);
      document.documentElement.classList.remove('auth-page');
      document.body.classList.remove('auth-page');
      document.body.style.overflowY = '';
      const rootElement = document.getElementById('root');
      if (rootElement) {
        rootElement.classList.remove('auth-page');
      }
    };
  }, []);
}
